import { render } from "./Config_Boutique.vue?vue&type=template&id=c7e00242"
import script from "./Config_Boutique.vue?vue&type=script&lang=js"
export * from "./Config_Boutique.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__